import {
	COUPONS_CREATE,
	COUPONS_CREATE_SUCCESS,
	COUPONS_CREATE_FAIL,
	COUPONS_UPDATE,
	COUPONS_UPDATE_SUCCESS,
	COUPONS_UPDATE_FAIL,
	COUPONS_RESET,
	COUPONS_RESET_SUCCESS,
	COUPONS_RESET_FAIL,
	COUPONS_COPY,
	COUPONS_COPY_SUCCESS,
	COUPONS_COPY_FAIL,
	COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS,
	COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS,
	COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL,
	COUPONS_GET_DETAILS,
	COUPONS_GET_DETAILS_SUCCESS,
	COUPONS_GET_DETAILS_FAIL,
	COUPONS_GET_OPTIONS,
	COUPONS_GET_OPTIONS_SUCCESS,
	COUPONS_GET_OPTIONS_FAIL,
} from 'Constants/actionTypes';

export const couponsCreate = (data) => ({
	type: COUPONS_CREATE,
	payload: data,
});

export const couponsCreateSuccess = (data) => ({
	type: COUPONS_CREATE_SUCCESS,
	payload: data,
});

export const couponsCreateFail = (error) => ({
	type: COUPONS_CREATE_FAIL,
	payload: error,
});

export const couponsUpdate = (data) => ({
	type: COUPONS_UPDATE,
	payload: data,
});

export const couponsUpdateSuccess = (data) => ({
	type: COUPONS_UPDATE_SUCCESS,
	payload: data,
});

export const couponsUpdateFail = (error) => ({
	type: COUPONS_UPDATE_FAIL,
	payload: error,
});

export const couponsReset = (data) => ({
	type: COUPONS_RESET,
	payload: data,
});

export const couponsResetSuccess = (data) => ({
	type: COUPONS_RESET_SUCCESS,
	payload: data,
});

export const couponsResetFail = (error) => ({
	type: COUPONS_RESET_FAIL,
	payload: error,
});

export const couponsCopy = (data) => ({
	type: COUPONS_COPY,
	payload: data,
});

export const couponsCopySuccess = (data) => ({
	type: COUPONS_COPY_SUCCESS,
	payload: data,
});

export const couponsCopyFail = (error) => ({
	type: COUPONS_COPY_FAIL,
	payload: error,
});

export const couponsFindAllByPageAndOptions = (params) => ({
	type: COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS,
	payload: params,
});

export const couponsFindAllByPageAndOptionsSuccess = (data) => ({
	type: COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS,
	payload: data,
});

export const couponsFindAllByPageAndOptionsFail = (error) => ({
	type: COUPONS_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL,
	payload: error,
});

export const couponsGetDetails = (brNo) => ({
	type: COUPONS_GET_DETAILS,
	payload: brNo,
});

export const couponsGetDetailsSuccess = (data) => ({
	type: COUPONS_GET_DETAILS_SUCCESS,
	payload: data,
});

export const couponsGetDetailsFail = (error) => ({
	type: COUPONS_GET_DETAILS_FAIL,
	payload: error,
});

export const couponsGetOptions = () => ({
	type: COUPONS_GET_OPTIONS,
});

export const couponsGetOptionsSuccess = (data) => ({
	type: COUPONS_GET_OPTIONS_SUCCESS,
	payload: data,
});

export const couponsGetOptionsFail = (error) => ({
	type: COUPONS_GET_OPTIONS_FAIL,
	payload: error,
});
